import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { ModificationSerializer3ubms8rrlijys as ModificationSerializer } from './ModificationSerialization.mjs';
import { PairSerializerpzh6nuee9oov as PairSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tuples.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.Mask', null, 1);
        tmp0_serialDesc.c1b('pairs', true);
        this.c2j_1 = tmp0_serialDesc;
      }
      d2j(typeSerial0) {
        return $serializer().t40(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.d2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static u40() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.Mask', $this, 1);
        tmp0_serialDesc.c1b('pairs', true);
        $this.r40_1 = tmp0_serialDesc;
        return $this;
      }
      v40(encoder, value) {
        var tmp0_desc = this.r40_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.l2j_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 0, new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.s40_1), new (ModificationSerializer())(this.s40_1))), value.l2j_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v40(encoder, value instanceof Mask() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r40_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.s40_1), new (ModificationSerializer())(this.s40_1))), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.s40_1), new (ModificationSerializer())(this.s40_1))), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return Mask().w40(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.r40_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ArrayListSerializer())(new (PairSerializer())(new (ConditionSerializer())(this.s40_1), new (ModificationSerializer())(this.s40_1)))];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.s40_1];
      }
      static t40(typeSerial0) {
        var $this = this.u40();
        $this.s40_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var MaskClass;
function Mask() {
  if (MaskClass === VOID) {
    class $ {
      constructor(pairs) {
        Companion_getInstance();
        var tmp;
        if (pairs === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = pairs;
        }
        pairs = tmp;
        this.l2j_1 = pairs;
      }
      o2j(pairs) {
        return new (Mask())(pairs);
      }
      toString() {
        return 'Mask(pairs=' + toString(this.l2j_1) + ')';
      }
      hashCode() {
        return hashCode(this.l2j_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Mask()))
          return false;
        if (!equals(this.l2j_1, other.l2j_1))
          return false;
        return true;
      }
      static w40(seen0, pairs, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().c2j_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.l2j_1 = emptyList();
        } else
          $this.l2j_1 = pairs;
        return $this;
      }
    }
    initMetadataForClass($, 'Mask', Mask, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    MaskClass = $;
  }
  return MaskClass;
}
//region block: exports
export {
  $serializer as $serializernhzjle7ewkqe,
  Mask as Mask3fc1c3tjgnucb,
  Companion_getInstance as Companion_getInstance2zg1j1fxqbni0,
};
//endregion

//# sourceMappingURL=Mask.mjs.map
